import { useState, useEffect, useRef } from 'react';
import { format } from 'date-fns';

const useCountdown = ({ onFinish }) => {
  const [timeLeft, setTimeLeft] = useState({ minutes: 0, seconds: 0 });
  const [started, setStarted] = useState(false);
  const expired = started && (timeLeft.minutes === 0 && timeLeft.seconds === 0);
  const timerRef = useRef(null);

  const finishTimer = () => {
    clearInterval(timerRef.current);
    setTimeLeft({ minutes: 0, seconds: 0 });
    onFinish && onFinish();
  };

  const calculateTimeLeft = (deadline) => {
    const currentTimeTimeZone = new Date().toLocaleString('en', { timeZone: 'America/Sao_Paulo' });
    const fomattedCurrentTime = format(new Date(currentTimeTimeZone), 'yyyy-MM-dd HH:mm:ss');

    const currentTime = new Date(fomattedCurrentTime).getTime();
    const targetTime = new Date(deadline).getTime();
    const difference = targetTime - currentTime;

    if (difference > 0) {
      const minutes = Math.floor((difference / 1000 / 60) % 60);
      const seconds = Math.floor((difference / 1000) % 60);
      setTimeLeft({ minutes, seconds });
    }

    if (difference <= 0) {
      finishTimer();
    }
  };

  const startTimer = ({ deadline }) => {
    setStarted(true);
    calculateTimeLeft(deadline);
    timerRef.current = setInterval(() => calculateTimeLeft(deadline), 1000);
  };

  const resetTimer = () => {
    clearInterval(timerRef.current);
    setStarted(false);
    setTimeLeft({ minutes: 0, seconds: 0 });
  };

  useEffect(() => () => clearInterval(timerRef.current), []);

  const numberWithZero = value => String(value).padStart(2, '0');
  const formatTime = ({ minutes, seconds }) => `${numberWithZero(minutes)}:${numberWithZero(seconds)}`;

  return {
    time: formatTime(timeLeft),
    started,
    expired,
    startTimer,
    resetTimer,
  };
};

export default useCountdown;
